import React from 'react';
import { Container } from '@mui/material';
import { AppToolbar } from '../../components/AppToolbar';
import { AppButton } from '../../components/AppButton';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ClassesServices } from '../../services/classes.service';
import { useSnackbar } from '../../hooks/snackbar.hook';
import { HttpResponse } from '../../services/base.service';
import { OptionType } from '../../components/AppAutocompleteField';
import { ExerciseType } from '../../types/exercise.type';
import { ExercisesServices } from '../../services/exercises.service';
import { ExercisePicker } from '../common/ExercisePicker';
import { WorkoutExercisesType } from '../../types/workout.type';

export function CLassExercisesEdit() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const instanceId = params.get('instance_id');

    const { showSnackbar } = useSnackbar();

    const [classExercises, setClassExercises] = React.useState<WorkoutExercisesType[]>([]);
    const [exercisesList, setExercisesList] = React.useState<OptionType<number>[]>([]);

    React.useEffect(() => {

        const fetchExercises = async () => {
            try {
                let resp: HttpResponse<WorkoutExercisesType[]>;

                resp = await ClassesServices.getInstanceExercises(Number(instanceId));

                setClassExercises(resp.data);
            } catch (error) {
                const msg = (error as any).response?.data?.message || 'An error occurred';
                console.error(msg, error);
                showSnackbar(msg, 'error');
            }
        };

        fetchExercises();

        ExercisesServices.getAll().then((resp: HttpResponse<ExerciseType[]>) => {
            setExercisesList(resp.data.map((e: ExerciseType) => {
                return {
                    id: e.id,
                    name: e.name,
                    video: e.video
                }
            }));
        })

    }, []);

    const handleBack = () => {
        navigate(-1);
    }

    const handleExerciseChange = (exerciseId: number, stationNumber: number) => {

        const changeExercise = async () => {
            try {
                await ClassesServices.updateClassExercise({
                    instance_id: parseInt(instanceId!),
                    exercise_id: exerciseId,
                    station_number: stationNumber,
                });

                //Update the local state
                // Update the local state to reflect the changes
                setClassExercises((prevExercises) =>
                    prevExercises.map((exercise) =>
                        exercise.station_number === stationNumber
                            ? { ...exercise, exercise_id: exerciseId, exercise: exercisesList.find((e) => e.id === exerciseId) }
                            : exercise
                    )
                );

                // Show notification
                showSnackbar('Exercise updated successfully!', 'success');
            } catch (error) {
                const msg = (error as any).response?.data?.message || 'Failed to update exercise';
                console.error(msg, error);
                showSnackbar(msg, 'error');
            }
        };

        changeExercise();

    };

    return (
        <Container>
            <AppToolbar title={`Edit Class Exercises`}>
                <AppButton startIcon={<ArrowBack />} onClick={handleBack}>
                    Back
                </AppButton>
            </AppToolbar>
            <Container>
                {classExercises.map((classWorkoutExercise: WorkoutExercisesType, index: number) => (
                    <ExercisePicker
                        key={`${index}.${classWorkoutExercise.id}`}
                        label={'Station ' + classWorkoutExercise.station_number}
                        onChange={(exerciseId: number) => {
                            if (exerciseId != undefined) {
                                handleExerciseChange(exerciseId, classWorkoutExercise.station_number!);
                            }
                        }}
                        options={exercisesList}
                        exercise={classWorkoutExercise.exercise!!}
                    />
                ))}
            </Container>
        </Container >
    );
};
